import { css } from '@emotion/css';
import { theme } from 'core/theme';

export const root = css`
  &.MuiSnackbarContent-root {
    flex-wrap: nowrap;
    background-color: ${theme.palette.common.white};
  }
`;

export const content = css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${theme.spacing(4)};

  ${theme.breakpoints.up('sm')} {
    grid-template-columns: 1fr auto;
  }
`;

export const textContainer = css`
  display: flex;
  flex-direction: column;
`;

export const buttonContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
  ${theme.breakpoints.up('md')} {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
`;
